import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {camelObj} from '../common/ConversionMethod';
import SearchBox from '../common/SearchBoxComponent';

export default function YearlyInspectionAdmin() {
	const {dataSource, setDataSource, setCopyDataSource, setCurrentItem} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/admin/api!organizationAndYearCheck.do?type=Inspection';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const detailClick = (item) => {
		setCurrentItem(camelObj(item));
		window.open(Arguments.reactUrl + '/society/yearly-inspection-admin/detail', '_self');
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '社会组织',
			dataIndex: 'organization_name',
			width: 300,
		},
		{
			title: '年检年度',
			dataIndex: 'year',
			width: 150,
		},
		{
			title: '公示状态',
			dataIndex: 'public_show_state',
			width: 150,
		},
		{
			title: '操作',
			width: 150,
			render: (item) => (
				<Button type="link" onClick={() => detailClick(item)}>查看详情</Button>
			),
		},
	];

	const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<SearchBox placeholder="请输入社会组织关键字"/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}

